import React, { useState, useEffect, useRef} from "react";
import { useManualQuery, useMutation } from "graphql-hooks";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

import { SEARCH_TOYS } from "./graphQL/search_qry";
import AuthWrapper from "./AuthWrapper";
import FloatingMenu from "./components/FloatingMenu";

export default function SearchResultsPage() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("q"); // <-- "children"
  const [searchResults, setSearchResults] = useState([]);
  const [floatMenuLeftMargin, setFloatMenuLeftMargin] = useState(0);

  const [fetchSearchResults] = useManualQuery(SEARCH_TOYS, {
      variables: {
        searchKeyword: query,
      },
    skip: !query,
  });
  
 const getSearchResultsList = async () => {
    const {
      loading: searchLoading,
      error: searchError,
      data: searchData,
    } = await fetchSearchResults();

    if (!searchLoading && searchData && searchData.searchResults) {
      console.log(searchData.searchResults);
      setSearchResults(searchData.searchResults);
    }
    if(searchError){
      console.log(searchError)
    } else {
    }
  };
  
  useEffect(() => {
    window.scrollTo(0, 0);
    getSearchResultsList();
  }, [query]);

  // Set floating menu place based on screen size
  useEffect(() => {
    const handleResize = () => {      
      setFloatMenuLeftMargin(window.innerWidth - 100);
    };

    // Set initial value
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);
  }, []);

  const columns = [
    { field: "id", headerName: "UUID", flex: 1 },
    { field: "title", headerName: "Title", flex: 1 },
    { field: "description", headerName: "Description", flex: 1 },
    { field: "category", headerName: "Category", flex: 1 },
    { field: "subcategory", headerName: "Subcategory", flex: 1 },
    { field: "brand", headerName: "Brand", flex: 1 },
  ];

  const rows = searchResults.map(item => ({
    id: item.uuid,
    title: item.title,
    description: item.__typename === 'ToyType' ? item.description : 'NA',
    category: item.__typename === 'ToyType' ? item.categoryId.title : 'NA',
    subcategory: item.__typename === 'ToyType' ? item.subCategoryId.title : 'NA',
    brand: item.__typename === 'ToyType' ? item.brandId.title : 'NA',
  }));

  return (
  <AuthWrapper>
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" mb={2}>
        Search Results for: "{query}"
      </Typography>

        <DataGrid
          rows={rows}
          columns={columns}
          autoHeight
          pageSize={10}
          disableRowSelectionOnClick
        />

        <FloatingMenu left={floatMenuLeftMargin} />
    </Box>
  </AuthWrapper>
  );
}
